/* Swipe and arrow-key navigation, shared by the two galleries on this site: the hero
   slideshow and the product page's photographs.

   window.galleryNav(surface, { prev, next, label })

   surface  the element a finger actually lands on — the photograph, not the whole section,
            so a swipe across body copy does not change the slide.
   prev/next callbacks. The caller owns what a slide IS; this file only decides when.

   Two rules worth keeping:

   Vertical scrolling must survive. A gesture only counts as a swipe when it is decisively
   horizontal — 40px of travel and at least 1.5x more across than down — so a fingertip
   drifting sideways while scrolling the page does not flip the photograph. touch-action
   is pan-y on the surface, which lets the browser keep owning vertical panning and stops
   it owning the horizontal, so there is no scroll-versus-swipe fight to arbitrate.

   Arrow keys need somewhere to land. The surface takes tabindex="0" and a group role, so
   it is reachable by keyboard on its own; the listener is on the surface rather than the
   document, so arrows only move the gallery the reader is actually in, and two galleries
   on one page cannot both answer the same keypress. The dots and thumbnails sit outside
   the surface on every gallery here, so a keypress on a focused dot never reaches this
   listener — each slideshow gives its own dot row a second one with the same two keys. */
(function () {
  var THRESHOLD = 40;      /* px of travel before a drag is a swipe at all */
  var DOMINANCE = 1.5;     /* how much more horizontal than vertical it has to be */

  window.galleryNav = function (surface, opts) {
    if (!surface || surface.dataset.navReady) return;
    surface.dataset.navReady = 'true';

    var startX = 0, startY = 0, tracking = false, pointer = null;

    /* pinch-zoom is named explicitly: 'pan-y' alone suppresses it, and these surfaces are
       the largest photograph on the site and a block of quote text — the two things a
       low-vision reader is most likely to try to enlarge. */
    surface.style.touchAction = 'pan-y pinch-zoom';

    surface.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      /* One finger owns the gesture. Without this the second finger of a pinch overwrites
         startX, and letting go can travel far enough sideways to flip the slide. */
      if (tracking) { tracking = false; pointer = null; return; }
      tracking = true;
      pointer = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
    });

    surface.addEventListener('pointerup', function (e) {
      if (!tracking || e.pointerId !== pointer) return;
      tracking = false;
      pointer = null;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) < THRESHOLD) return;
      if (Math.abs(dx) < Math.abs(dy) * DOMINANCE) return;
      /* Swiping left drags the next photograph in from the right, which is the direction
         the gesture implies rather than the direction the finger moved. */
      if (dx < 0) { opts.next(); } else { opts.prev(); }
    });

    surface.addEventListener('pointercancel', function () { tracking = false; pointer = null; });
    surface.addEventListener('pointerleave', function () { tracking = false; pointer = null; });

    if (!surface.hasAttribute('tabindex')) surface.setAttribute('tabindex', '0');
    if (!surface.hasAttribute('role')) surface.setAttribute('role', 'group');
    if (opts.label && !surface.hasAttribute('aria-label')) surface.setAttribute('aria-label', opts.label);

    surface.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { opts.prev(); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { opts.next(); e.preventDefault(); }
    });
  };
})();
